import React, { Dispatch, ReactElement, SetStateAction } from "react";
import { Switch } from "@headlessui/react";
import NexstarTooltip from "../../../utils/components/tailwind/NexstarTooltip";

type ToggleProps = {
  checked: any;
  dataTestId?: string;
  label?: string;
  name: string;
  onChange: Dispatch<SetStateAction<boolean>>;
  id?: string;
  lightColorScheme?: boolean;
  disabled?: boolean;
  tooltip?: string;
  className?: string;
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AlertsToggle({
  checked,
  dataTestId,
  label,
  name,
  onChange,
  id,
  lightColorScheme,
  disabled,
  tooltip,
  className,
}: ToggleProps): ReactElement {
  return (
    <Switch.Group as="div" className="flex items-center" id={id}>
      <div className="flex gap-2">
        <Switch.Label as="span" className="mr-1 text-sm leading-4">
          <span
            className={`text-xs ${
              lightColorScheme ? "text-NexstarBlue" : "text-white"
            }`}
          >
            {label}
          </span>
        </Switch.Label>
        {tooltip ? <NexstarTooltip content={tooltip} /> : null}
      </div>
      <Switch
        id={`${id}-switch`}
        name={name}
        checked={checked}
        onChange={onChange}
        className={`group relative inline-flex h-3 w-6 flex-shrink-0 cursor-pointer items-center justify-center rounded-full ${className}`}
        disabled={disabled}
        data-testid={dataTestId}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className="pointer-events-none absolute h-full w-full rounded-md bg-transparent"
        />
        <span
          aria-hidden="true"
          className={`${
            checked ? "bg-NexstarOrange" : "bg-black bg-opacity-60"
          } pointer-events-none absolute mx-auto h-3 w-6 rounded-full transition-colors duration-200 ease-in-out`}
        />
        <span
          aria-hidden="true"
          className={classNames(
            checked ? "translate-x-3" : "translate-x-0",
            "pointer-events-none absolute left-0 inline-block h-3 w-3 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out",
          )}
        />
      </Switch>
    </Switch.Group>
  );
}
